import React, { useState } from 'react';
import { CalendarIcon, FilterIcon, XIcon } from 'lucide-react';
interface DateRangeFilterProps {
  dateRange: {
    start: Date | null;
    end: Date | null;
    preset?: string;
  };
  onChange: (range: {
    start: Date | null;
    end: Date | null;
    preset?: string;
  }) => void;
}
export function DateRangeFilter({
  dateRange,
  onChange
}: DateRangeFilterProps) {
  const [isOpen, setIsOpen] = useState(false);
  const presets = [{
    label: "Dall'inizio",
    value: 'all',
    start: null,
    end: null
  }, {
    label: 'Ultimo mese',
    value: 'last-month',
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    end: new Date()
  }, {
    label: 'Ultimi 3 mesi',
    value: 'last-3-months',
    start: new Date(new Date().setMonth(new Date().getMonth() - 3)),
    end: new Date()
  }, {
    label: 'Ultimi 6 mesi',
    value: 'last-6-months',
    start: new Date(new Date().setMonth(new Date().getMonth() - 6)),
    end: new Date()
  }, {
    label: 'Ultimo anno',
    value: 'last-year',
    start: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
    end: new Date()
  }];
  const handlePresetChange = (preset: any) => {
    onChange({
      start: preset.start,
      end: preset.end,
      preset: preset.value
    });
    setIsOpen(false);
  };
  const handleCustomDateChange = (type: 'start' | 'end', date: string) => {
    onChange({
      ...dateRange,
      [type]: date ? new Date(date) : null,
      preset: 'custom'
    });
  };
  const formatDate = (date: Date | null) => {
    if (!date) return '';
    return date.toISOString().split('T')[0];
  };
  const getActiveLabel = () => {
    if (dateRange.preset === 'all') return "Dall'inizio";
    if (dateRange.preset === 'custom') {
      const start = dateRange.start ? formatDate(dateRange.start).replace(/-/g, '/') : '...';
      const end = dateRange.end ? formatDate(dateRange.end).replace(/-/g, '/') : '...';
      return `${start} - ${end}`;
    }
    return presets.find(p => p.value === dateRange.preset)?.label || 'Periodo';
  };
  const resetFilter = () => {
    onChange({
      start: null,
      end: null,
      preset: 'all'
    });
    setIsOpen(false);
  };
  return <div className="relative" data-id="element-985">
      <button type="button" className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={() => setIsOpen(!isOpen)} data-id="element-986">
        <CalendarIcon className="h-4 w-4 mr-2" data-id="element-987" />
        {getActiveLabel()}
        {dateRange.preset !== 'all' && <XIcon className="h-4 w-4 ml-2 text-gray-400 hover:text-gray-500" onClick={e => {
        e.stopPropagation();
        resetFilter();
      }} data-id="element-988" />}
      </button>
      {isOpen && <div className="origin-top-right absolute right-0 mt-2 w-72 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10" data-id="element-989">
          <div className="py-1 divide-y divide-gray-200" data-id="element-990">
            <div className="px-4 py-2" data-id="element-991">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-992">
                Periodi predefiniti
              </h3>
              <div className="mt-2 space-y-2" data-id="element-993">
                {presets.map(preset => <button key={preset.value} type="button" className={`w-full text-left px-2 py-1 text-sm rounded-md ${dateRange.preset === preset.value ? 'bg-blue-100 text-blue-900' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => handlePresetChange(preset)} data-id="element-994">
                    {preset.label}
                  </button>)}
              </div>
            </div>
            <div className="px-4 py-2" data-id="element-995">
              <h3 className="text-sm font-medium text-gray-900" data-id="element-996">
                Periodo personalizzato
              </h3>
              <div className="mt-2 space-y-3" data-id="element-997">
                <div data-id="element-998">
                  <label htmlFor="start-date" className="block text-xs font-medium text-gray-500" data-id="element-999">
                    Data inizio
                  </label>
                  <input type="date" id="start-date" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formatDate(dateRange.start)} onChange={e => handleCustomDateChange('start', e.target.value)} data-id="element-1000" />
                </div>
                <div data-id="element-1001">
                  <label htmlFor="end-date" className="block text-xs font-medium text-gray-500" data-id="element-1002">
                    Data fine
                  </label>
                  <input type="date" id="end-date" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" value={formatDate(dateRange.end)} onChange={e => handleCustomDateChange('end', e.target.value)} data-id="element-1003" />
                </div>
              </div>
            </div>
            <div className="px-4 py-2 flex justify-end" data-id="element-1004">
              <button type="button" className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={() => setIsOpen(false)} data-id="element-1005">
                Applica
              </button>
            </div>
          </div>
        </div>}
    </div>;
}